import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  createTalentoService,
  getTalentoByIdService,
  getTalentosService,
  toggleTalentoActiveService,
  updateTalentoService,
} from "../../../services/talentos/talentos.service";

export const getTalentosThunk = createAsyncThunk(
  "talentos/getAll",
  async ({ page = 1, search = "" } = {}, { rejectWithValue }) => {
    try {
      return await getTalentosService(page, search);
    } catch (error) {
      if (error.response?.status === 404) {
        return rejectWithValue("Página no válida");
      }
      const message =
        error.response?.data?.detail ||
        error.response?.data?.message ||
        "Error al obtener talentos";

      return rejectWithValue(message);
    }
  }
);

export const createTalentoThunk = createAsyncThunk(
  "talentos/create",
  async (payload, { rejectWithValue }) => {
    try {
      return await createTalentoService(payload);
    } catch (error) {
      const message =
        error.response?.data?.detail ||
        error.response?.data?.message ||
        "Error al crear talento";

      return rejectWithValue(message);
    }
  }
);

export const getTalentoByIdThunk = createAsyncThunk(
  "talentos/getById",
  async (id, { rejectWithValue }) => {
    try {
      return await getTalentoByIdService(id);
    } catch (error) {
      const message =
        error.response?.data?.detail ||
        error.response?.data?.message ||
        "Error al obtener talento";

      return rejectWithValue(message);
    }
  }
);

export const updateTalentoThunk = createAsyncThunk(
  "talentos/update",
  async ({ id, payload }, { rejectWithValue }) => {
    try {
      return await updateTalentoService(id, payload);
    } catch (error) {
      const message =
        error.response?.data?.detail ||
        error.response?.data?.message ||
        "Error al actualizar talento";

      return rejectWithValue(message);
    }
  }
);

export const toggleTalentoActiveThunk = createAsyncThunk(
  "talentos/toggleActive",
  async (id, { rejectWithValue }) => {
    try {
      return await toggleTalentoActiveService(id);
    } catch (error) {
      const message =
        error.response?.data?.detail ||
        error.response?.data?.message ||
        "Error al cambiar estado";

      return rejectWithValue(message);
    }
  }
);
